// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"398d6548","239":"92cc9330","732":"f23ccae7"}[chunkId] + ".chunk.js";
};